import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates, Button } from '@cordata/buffet';
import { useParams, useHistory } from 'react-router-dom';
import { deburrObject } from '~/utils/api/normalizers';
import { authorizedPyInstance as Py } from '~/utils';

import { Form } from '~/components/Allergy';

const AllergiesDetails = () => {
  const { allergyId, ...p } = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();
  const history = useHistory();
  const [deleteStatus, setDeleteStatus] = useState();

  useEffect(() => {
    if (allergyId !== 'add') {
      Py
        .get(`api/data/public/patient-allergy/${allergyId}`)
        .then(r => deburrObject(r.data.data))
        .then(r => Object.keys(r).reduce((a, m) => {
          return {
            ...a,
            [m]: r[m] && typeof r[m] === 'object' && !Array.isArray(r[m]) ? deburrObject(r[m]) : r[m],
          };
        }, {}))
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setData({});
      setStatus('success');
    }
  }, [allergyId]);

  const handleDelete = () => {
    setDeleteStatus('working');

    Py
      .delete(`api/data/public/patient-allergy/${allergyId}`)
      .then(() => history.goBack());
  };

  if (status === 'success') {
    return (
      <>
        <PageTitle
          action={
            <Button
              outline
              color="danger"
              icon="trash"
              disabled={allergyId === 'add' || deleteStatus === 'working'}
              onClick={handleDelete}
            >
              Remove Allergy
            </Button>
          }
        >
          Allergies
        </PageTitle>

        <Form
          data={{
            ...data,
            patientUid: { id: p.patient_id },
          }}
        />
      </>
    );
  }

  return <PseudoStates status={status} />;
};

export default AllergiesDetails;
